/**
 * Value shapes a dynamic form field can hold. Shared by the builder preview
 * and (Phase 3) the inductee renderer + submit payload.
 */

import type { AddressValue, DamageMarkupValue } from '@hcc/types';

/** Grid value: rowKey -> (columnKey -> cell value). */
export type GridValue = Record<string, Record<string, string>>;

export type FieldValue =
  | string
  | string[]
  | number
  | boolean
  | GridValue
  | AddressValue
  | DamageMarkupValue
  | null;

export type FormValues = Record<string, FieldValue>;

/** Coerce a field value to a string, for single-value controls. */
export function asString(v: FieldValue): string {
  return typeof v === 'string' ? v : '';
}

/** Coerce a field value to a string array, for multi-value controls. */
export function asArray(v: FieldValue): string[] {
  return Array.isArray(v) ? v : [];
}
